module.exports = __webpack_public_path__ + "img/purchase-3.d4af6e00.svg";